// import './App.css';
import Path from './routes/Path';
import './assets/css/style.css'
import 'react-tabs/style/react-tabs.css';
import 'react-toastify/dist/ReactToastify.css';
import { LanguageProvider } from './contexts/LanguageContext';
import { ToastContainer } from 'react-toastify';

function App() {
  return (
    <LanguageProvider>
      <div className=''>
          <Path/> 
          <ToastContainer />
      </div>
    </LanguageProvider>
  );
}

export default App;
